<template>
	<v-col class="history-transfer">
		<ModalSearch ref="modalSearch" @action="cari"></ModalSearch>
		<ModalView ref="modalviews" :params="prospekData"></ModalView>

		<div class="d-flex justify-space-between">
			<div class="text-h5 cl-primary">Calon Prospek Mitra</div>
		</div>
		<div class="pt-1 pb-2 d-flex font-size-10 grey--text">
			<v-icon small color="grey">mdi-account-group</v-icon>
			<div class="pl-2">Jaringan</div>
			<div class="px-2">/</div>
			<div>Calon Prospek Mitra</div>
		</div>

		<template v-if="!loading">
			<div class="mt-5">
				<v-row>
					<v-col cols="6" sm="6" md="6" class="py-0 py-sm-3">
						<v-btn depressed color="primary" class="white--text rounded-lg text-capitalize" v-if="false">
							<v-icon small>mdi-file-excel</v-icon>
							<span class="pl-2 d-none d-sm-block">Eksport Excel</span>
						</v-btn>
					</v-col>
					<v-col cols="6" sm="6" md="6" class="py-0 py-sm-3">
						<div class="d-flex justify-end">
							<v-btn depressed color="primary" class="white--text rounded-lg text-capitalize" @click="showSearch">
								<div class="d-flex">
									<v-icon small class="d-block d-sm-none">mdi-magnify</v-icon>
									<div class="d-none d-sm-block">Cari</div>
								</div>
							</v-btn>
							<v-btn depressed color="grey lighten-1" class="ml-3 white--text rounded-lg text-capitalize" @click="reset">Reset</v-btn>
						</div>
					</v-col>
				</v-row>
				<v-row v-if="listProspek.length > 0">
					<v-col cols="12" class="pt-0">
						<v-simple-table class="white-row table-vo table-history-bonus">
							<template v-slot:default>
								<thead class="">
									<tr>
										<th class="text-left">Tanggal Daftar</th>
										<th class="text-left" width="20%">Nama Calon Prospek</th>
										<th class="text-left" width="20%">Email</th>
										<th class="text-left">No. Handphone</th>
										<th class="text-left">Asal Kota</th>
										<th class="text-center">Aksi</th>
									</tr>
								</thead>
								<tbody class="grey--text text--darken-3">
									<tr v-for="prospek in listProspek" :key="prospek.member_prospect_id">
										<td class="text-left">{{ prospek.member_prospect_input_datetime | tanggal }}</td>
										<td class="text-left"><div v-html="$options.filters.longText(prospek.member_prospect_name, 25)"></div></td>
										<td class="text-left">{{ prospek.member_prospect_email }}</td>
										<td class="text-left">{{ prospek.member_prospect_mobilephone }}</td>
										<td class="text-left">{{ prospek.member_prospect_city_name }} {{ ', ' + prospek.member_prospect_province_name }}</td>
										<td class="text-center">
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-btn depressed small color="blue" v-bind="attrs" v-on="on" @click="showDetail(prospek.member_prospect_id)">
														<v-icon small color="white">mdi-account-search-outline</v-icon>
													</v-btn>
												</template>
												<span>Detail Calon Prospek</span>
											</v-tooltip>
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-btn depressed small color="green darken-3" v-bind="attrs" v-on="on" @click="goRegisterProspek(prospek.member_prospect_id)" class="my-1 my-md-0 ml-md-2">
														<v-icon small color="white">mdi-account-multiple-plus-outline</v-icon>
													</v-btn>
												</template>
												<span>Daftarkan</span>
											</v-tooltip>
										</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table>
					</v-col>
				</v-row>
				<div class="mt-3" v-if="listProspek.length == 0">
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<v-card class="py-3 elevation-0 hover-shadow rounded-lg">
								<NoData></NoData>
								<div class="pt-3 text-center cl-secondary">Tidak ada data calon prospek mitra yang dapat ditampilkan</div>
							</v-card>
						</v-col>
					</v-row>
				</div>
				<div v-if="listProspek.length > 0">
					<v-row justify="end">
						<v-col cols="12" sm="5" md="6" class="pl-1 pr-0 pb-1 pr-sm-3 pb-sm-3 d-flex justify-sm-start justify-end">
							<v-pagination v-model="page" total-visible="5" class="d-flex justify-end vo-pagination no-button-focus" color="primary" :length="prospekPagination.total_page" @input="changePage"></v-pagination>
						</v-col>
						<v-col cols="12" sm="5" md="5" class="pb-0 pb-sm-3 my-auto text-right">
							<div class=" font-size-10">Menampilkan {{ prospekPagination.total_display }} data dari total {{ prospekPagination.total_data }} data</div>
						</v-col>
						<v-col cols="4" sm="2" md="1">
							<v-autocomplete :items="listLimit" v-model="limit" hide-details dense class="" placeholder="Data" color="primary" @input="changeLimit"></v-autocomplete>
						</v-col>
					</v-row>
				</div>
			</div>
		</template>

		<template v-else>
			<v-row class="mt-5">
				<v-col cols="12" sm="12" md="12">
					<LoadData :loading="loading"></LoadData>
				</v-col>
			</v-row>
		</template>
	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ModalSearch from './components/ModalSearch';
import ModalView from './components/ModalView';

export default {
	components: {
		ModalSearch, ModalView
	},
	data() {
		return {
			loading: false,
			transferDate: false,
			dateTransfer: '',
			page: 1,
			limit: '10',
			listLimit: [ '5', '10', '20', '50', '100' ],
			params: [],
			prospekData: null
		}
	},
	computed: {
		...mapState('auth', ['userData']),
		...mapState('network', ['listProspek', 'prospekPagination']),
	},
	methods: {
		...mapActions('network', ['getProspekList']),

		goRegisterProspek(id) {
			this.$router.push({ path: 'registrasi-mitra', query: { idProspek: id, page: this.page, limit: this.limit }})
		},

		goActivation(member_id) {
			this.$router.push({name: 'aktivasi-mitra', query: { id: member_id }})
		},

		showSearch() {
			this.$refs.modalSearch.modalShow()
		},

		async showDetail(id) {
			const data = this.listProspek.find(x => x.member_prospect_id === id)
			if (data) {
				this.prospekData = data
				this.$refs.modalviews.modalShow()
			}
		},

		cari(data) {
			this.params = []
			this.page = 1

			if(data.name.value)
				this.params.push(data.name)

			if(data.email.value)
				this.params.push(data.email)

			if(data.handphone.value)
				this.params.push(data.handphone)

			if(data.date.value)
				this.params.push(data.date)

			this.getProspekList(this.queryString({sort: 'member_prospect_input_datetime', dir: 'DESC', limit:this.limit, page: this.page, params: this.params})).then(() => {
				this.$refs.modalSearch.modalHide()
			})
		},

		changePage(page) {
			this.page = page
			this.getData()
		},

		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},

		reset() {
			this.params = []
			this.page = 1
			this.limit = '10'
			this.getProspekList()
			this.$refs.modalSearch.reset()
		},

		getData() {
			this.loading = true
			this.getProspekList(this.queryString({sort: 'member_prospect_input_datetime', dir: 'DESC', limit:this.limit, page: this.page, params: this.params})).then(() => {
				document.body.scrollTop = 0
				document.documentElement.scrollTop = 0
				this.loading = false
			})
		},
	},

	async created() {
		this.$store.dispatch('setPageTitle', `Calon Prospek Mitra`)
		this.loading = await true
		await this.getProspekList({sort: 'member_prospect_input_datetime', dir: 'DESC', limit:this.limit, page: this.page})
		this.loading = false
	}
};
</script>

